
import Component from '../../../assets/scripts/modules/component'

const SPEED_MIN = 100000
const SPEED_MAX = 150000

class BalloonsComponent extends Component {
  init () {
    const balloonsElements = this.element.querySelectorAll('.balloon:not([data-position])')

    const singleMaps = [
      { positions: [ 'left' ], sizes: [ 'medium' ], directions: [ 'normal' ] },
      { positions: [ 'middle' ], sizes: [ 'tiny' ], directions: [ 'reverse' ] }
    ]

    const doubleMaps = [
      { positions: [ 'left', 'middle' ], sizes: [ 'tiny', 'small' ], directions: [ 'normal', 'reverse' ] },
      { positions: [ 'middle', 'right' ], sizes: [ 'small', 'tiny' ], directions: [ 'normal', 'reverse' ] }
    ]

    const tripleMaps = [
      { positions: [ 'middle', 'left', 'right' ], sizes: [ 'tiny', 'medium', 'small' ], directions: [ 'normal', 'reverse', 'normal' ] },
      { positions: [ 'middle', 'left', 'right' ], sizes: [ 'tiny', 'small', 'medium' ], directions: [ 'reverse', 'normal', 'reverse' ] }
    ]

    let map

    if (balloonsElements.length === 2) {
      map = doubleMaps[ Math.floor(Math.random() * (doubleMaps.length)) ]
    } else if (balloonsElements.length === 3) {
      map = tripleMaps[ Math.floor(Math.random() * (tripleMaps.length)) ]
    } else {
      map = singleMaps[ Math.floor(Math.random() * (singleMaps.length)) ]
    }

    balloonsElements.forEach((balloonElement, i) => {
      const balloonCircle = balloonElement.querySelector('.balloon__circle')

      balloonElement.setAttribute('data-position', map.positions[i]) // set balloon position
      balloonElement.setAttribute('data-size', map.sizes[i]) // set balloon size
      balloonCircle.style.animationDuration = (Math.floor(Math.random() * (SPEED_MAX - SPEED_MIN)) + SPEED_MIN) + 'ms' // set balloon speed
      balloonCircle.style.animationDirection = map.directions[i] // set balloon animation
    })
  }
}

window.addEventListener('init-load', () => {
  for (const element of document.querySelectorAll('.balloons-coop')) {
    element.instance = element.instance || new BalloonsComponent(element)
  }
})
